import { CarRental, DirectionsCar } from "@mui/icons-material";
import { Badge, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { GqlPlannerV2SummaryTravelMethod } from "~/__generated__";

import { ShiftItemTravelBadgesFragment } from "./fragments.generated";

type Props = {
    shift: ShiftItemTravelBadgesFragment;
};

export default function ShiftItemTravelBadges({ shift }: Props) {
    const { t } = useTranslation("fieldworker");
    const summary = shift.summary;

    const isCarTravel =
        summary.travelMethod === GqlPlannerV2SummaryTravelMethod.PrivateCar ||
        summary.travelMethod === GqlPlannerV2SummaryTravelMethod.MyWheels;
    const isCarpooling = isCarTravel && summary.numberOfPlannerTravelGroupParticipants > 1;
    const isMyWheels = summary.travelMethod === GqlPlannerV2SummaryTravelMethod.MyWheels;

    if (!isCarpooling && !isMyWheels) {
        return null;
    }

    return (
        <Stack direction="row" alignItems="center" gap={2}>
            {isMyWheels && (
                <Stack direction="row" alignItems="center" gap={0.5}>
                    <CarRental />
                    <Typography variant="caption" fontWeight="bold">
                        {t("shiftItem.labelMyWheels")}
                    </Typography>
                </Stack>
            )}
            {isCarpooling && (
                <Stack direction="row" alignItems="center" gap={0.5}>
                    <Badge
                        badgeContent={summary.numberOfPlannerTravelGroupParticipants}
                        color="secondary"
                        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                        slotProps={{
                            badge: {
                                sx: {
                                    minWidth: 16,
                                    height: 16,
                                    fontSize: 10,
                                    fontWeight: "bold",
                                },
                            },
                        }}
                    >
                        <DirectionsCar />
                    </Badge>
                    <Typography variant="caption" fontWeight="bold">
                        {t("shiftItem.labelCarpool")}
                    </Typography>
                </Stack>
            )}
        </Stack>
    );
}
